import React from 'react';
import { Button } from '@/components/ui/button';

interface CodeShortcutBarProps {
  onInsert: (text: string) => void;
}

const shortcuts = [
  { display: '( )', insert: '()' },
  { display: '{ }', insert: '{}' },
  { display: '[ ]', insert: '[]' },
  { display: '=>', insert: ' => ' },
  { display: '.', insert: '.' },
  { display: '/', insert: '/' },
  { display: ';', insert: ';' },
  { display: '"', insert: '""' },
  { display: "'", insert: "''" },
  { display: '`', insert: '``' },
  { display: '<', insert: '<' },
  { display: '>', insert: '>' },
  { display: '=', insert: ' = ' },
  { display: '+', insert: ' + ' },
  { display: '-', insert: ' - ' },
  { display: '*', insert: ' * ' },
  { display: 'Tab', insert: '  ' }, // 2 spaces for tab
];

export const CodeShortcutBar: React.FC<CodeShortcutBarProps> = ({ onInsert }) => {
  return (
    <div className="bg-background/90 backdrop-blur-sm border-t">
      <div className="w-full overflow-x-auto whitespace-nowrap p-1">
        <div className="flex items-center space-x-1">
          {shortcuts.map(({ display, insert }) => (
            <Button
              key={display}
              variant="ghost"
              size="sm"
              className="h-9 px-3 font-mono text-sm flex-shrink-0"
              onClick={() => onInsert(insert)}
              aria-label={`Insert ${display}`}
            >
              {display}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};